// Probierpaket-Produktseite: Umschalter Mixed/Vegan, ein Knopf, feste Leiste, Auswertung.
// Ein Probierpaket pro Bestellung: Der Rabatt „2x Gratis Protein Pasta“ gilt nur einmal, darum keine Mengenwahl.
(() => {
  const root = document.querySelector('[data-ppd]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-ppd-config]')?.textContent || '{}');
  const $ = sel => root.querySelector(sel);
  const $$ = sel => Array.from(root.querySelectorAll(sel));

  const el = {
    add: $('[data-ppd-add]'), addLabel: $('[data-ppd-add-label]'), addPrice: $('[data-ppd-add-price]'),
    checkout: $('[data-ppd-checkout]'), incart: $('[data-ppd-incart]'), error: $('[data-ppd-error]'),
    sticky: $('[data-mdp-sticky]'), stickyAdd: $('[data-ppd-sticky-add]'), stickyTitle: $('[data-ppd-sticky-title]'),
    stickyMsg: $('[data-ppd-sticky-msg]'), stickyPrice: $('[data-ppd-sticky-price]'), hero: $('[data-ppd-hero]'),
  };
  const packs = cfg.packs || [];
  const VERSION = cfg.template ? `${cfg.trackVersion} · ${cfg.template}` : cfg.trackVersion;
  let active = packs.find(p => p.n === cfg.active) || packs[0];
  let inCart = false; // irgendein Probierpaket liegt schon im Warenkorb
  let busy = false;

  const TX = cfg.texts || {};
  const t = (key, def, vars = {}) => String(TX[key] || def).replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
  // Preisformat je Währung: EUR „€119,86“, sonst wie das Shop-Format (z. B. Schweiz „CHF 149.50“)
  const CUR = window.Shopify?.currency?.active || 'EUR';
  const euro = cents => (CUR === 'EUR' ? `€${(cents / 100).toFixed(2).replace('.', ',')}` : `${CUR} ${(cents / 100).toFixed(2)}`);
  // Der Rabatt „2x Gratis Protein Pasta“ ist ein fester Euro-Betrag; Shopify rechnet ihn in anderen Währungen
  // mit dem Shop-Kurs um (10 € → CHF 9.40). Angezeigte Endpreise entsprechend anpassen.
  if (CUR !== 'EUR') {
    const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
    packs.forEach(p => {
      // Nur der feste €-Rabatt wird umgerechnet; ein Prozent-Rabatt gilt schon auf den Preis in der Shop-Währung
      const off = (p.fixedOff ?? (p.price - p.final)) || 0;
      const pctOff = p.pctOff || 0;
      if (off <= 0) return;
      p.final = p.price - pctOff - Math.round(off * rate);
      const box = document.querySelector(`.PPD__Price[data-ppd-pack="${p.n}"]`);
      if (!box) return;
      const finalEl = box.querySelector('[data-ppd-final]');
      if (finalEl) finalEl.textContent = euro(p.final);
      const portions = parseInt(box.dataset.ppdPortions, 10) || 0;
      const portionEl = box.querySelector('[data-ppd-portion]');
      if (portionEl && portions > 0) portionEl.textContent = (portionEl.dataset.ppdPortionText || '[price]').replace('[price]', euro(Math.floor(p.final / portions)));
    });
  }
  const packKey = p => (cfg.single ? (p?.handle || '') : (p?.n === 2 ? 'vegan' : 'mixed'));

  function track(event, data = {}) {
    const params = { mm_version: VERSION, mm_template: cfg.template || '', pack: packKey(active), dish: active?.title, plan: 'einmalig', ...data };
    try { window.Shopify?.analytics?.publish?.(event, params); } catch (err) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ mm: null }); window.dataLayer.push({ event, mm: params }); } catch (err) {}
  }

  function render() {
    $$('[data-ppd-pack]').forEach(n => { n.hidden = Number(n.dataset.ppdPack) !== active.n; });
    $$('[data-ppd-switch]').forEach(b => b.setAttribute('aria-checked', String(Number(b.dataset.ppdSwitch) === active.n)));
    el.addLabel.textContent = inCart ? cfg.addedLabel : cfg.addLabel;
    el.addPrice.textContent = inCart ? '' : euro(active.final);
    el.add.classList.toggle('is-done', inCart);
    el.add.setAttribute('aria-disabled', String(inCart));
    el.checkout.hidden = !inCart;
    el.incart.hidden = !inCart;
    if (el.stickyTitle) el.stickyTitle.textContent = active.title;
    if (el.stickyMsg) el.stickyMsg.textContent = inCart ? t('sticky_incart', 'Liegt im Warenkorb') : t('sticky_msg', '[price] · Gratis-Versand', { price: euro(active.final) });
    if (el.stickyAdd) {
      el.stickyAdd.firstElementChild.textContent = inCart ? t('sticky_checkout', 'Zur Kasse') : (cfg.stickyAdd || 'In den Warenkorb');
      el.stickyPrice.textContent = inCart ? '' : euro(active.final);
    }
  }

  // Mixed/Vegan: tauscht Inhalt, Preis, Titel und erstes Bild, die Adresse zeigt auf das gewählte Paket
  $$('[data-ppd-switch]').forEach(b => b.addEventListener('click', () => {
    const next = packs.find(p => p.n === Number(b.dataset.ppdSwitch));
    if (!next || next === active) return;
    active = next;
    if (el.hero && next.image) { el.hero.src = next.image; el.hero.removeAttribute('srcset'); }
    if (cfg.onPdp) { try { history.replaceState(null, '', next.url + window.location.search); } catch (err) {} }
    render();
    track('mm_probier_switch', { via: 'switch' });
  }));

  async function readCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const ids = packs.map(p => p.variantId);
    inCart = cart.items.some(i => ids.includes(i.variant_id));
    return cart;
  }

  async function add(via) {
    if (inCart) { track('mm_probier_checkout', { via }); window.location.href = '/checkout'; return; }
    if (busy) return;
    busy = true;
    el.error.hidden = true;
    root.classList.add('is-busy');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: active.variantId, quantity: 1 }] }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Unbekannter Fehler');
      track('mm_probier_add', { via, value: active.final / 100, full_value: active.price / 100, currency: CUR });
      const cart = await readCart();
      document.querySelectorAll('.Header__CartCount').forEach(n => { n.textContent = cart.item_count; });
      // Wie die bisherige Produktseite: Theme lädt den Flying Cart neu und öffnet ihn
      document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: active.variantId, quantity: 1 } }));
      render();
    } catch (err) {
      console.error('[PPD]', err);
      el.error.textContent = t('error', 'Das hat leider nicht geklappt: [message] Bitte versuch es noch einmal.', { message: err.message });
      el.error.hidden = false;
      track('mm_error', { message: String(err.message || err).slice(0, 150), via: 'probier' });
    } finally {
      busy = false;
      root.classList.remove('is-busy');
    }
  }
  el.add.addEventListener('click', () => add('probier'));
  el.stickyAdd?.addEventListener('click', () => add('probier_sticky'));
  el.checkout.addEventListener('click', () => track('mm_probier_checkout', { via: 'probier' }));
  $('[data-ppd-mm]')?.addEventListener('click', () => track('mm_probier_mm', { via: 'probier' }));
  $$('[data-ppd-more]').forEach(a => a.addEventListener('click', () => track('mm_probier_more', { via: cfg.template || '' })));

  // Galerie-Punkte und Pfeile (wie Gerichte-Seite)
  const slides = $('[data-mdp-slides]');
  const dotsWrap = $('[data-mdp-dots]');
  if (slides && dotsWrap && slides.children.length > 1) {
    const count = slides.children.length;
    const go = i => slides.scrollTo({ left: Math.max(0, Math.min(count - 1, i)) * slides.clientWidth, behavior: 'smooth' });
    const current = () => Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
    const dots = Array.from(slides.children).map((_, n) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Bild ${n + 1} von ${count}`);
      dot.addEventListener('click', () => go(n));
      return dotsWrap.appendChild(dot);
    });
    const prev = $('[data-mdp-prev]'), next = $('[data-mdp-next]');
    prev?.addEventListener('click', () => go(current() - 1));
    next?.addEventListener('click', () => go(current() + 1));
    const seen = new Set([0]);
    const sync = () => {
      const i = current();
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      if (prev) prev.hidden = i <= 0;
      if (next) next.hidden = i >= count - 1;
      if (!seen.has(i)) { seen.add(i); track('mm_probier_gallery', { pdp_slide: i + 1, pdp_slides: dots.length }); }
    };
    slides.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  // Feste Leiste (Handy): sichtbar, solange der Kaufknopf nicht im Bild ist
  const mobileMq = window.matchMedia('(max-width: 999px)');
  let stickySeen = false;
  if (el.sticky) {
    let raf = 0;
    const sync = () => {
      raf = 0;
      const r = el.add.getBoundingClientRect();
      const addVisible = r.bottom > 0 && r.top < window.innerHeight;
      const wasHidden = el.sticky.hidden;
      el.sticky.hidden = !mobileMq.matches || addVisible;
      root.classList.toggle('has-sticky', !el.sticky.hidden);
      if (wasHidden && !el.sticky.hidden && !stickySeen) { stickySeen = true; track('mm_probier_sticky_view'); }
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(sync); };
    window.addEventListener('scroll', () => { schedule(); setTimeout(sync, 120); }, { passive: true });
    window.addEventListener('resize', schedule);
    mobileMq.addEventListener('change', sync);
    sync();
  }

  // Desktop: Kaufbereich läuft mit; ist er höher als der Bildschirm, bleibt sein unteres Ende sichtbar
  const buy = root.querySelector('.MDP__Buy');
  const desktopMq = window.matchMedia('(min-width: 1000px)');
  const setStickyTop = () => {
    if (!buy) return;
    if (!desktopMq.matches) { buy.style.top = ''; return; }
    buy.style.top = `${Math.min(150, window.innerHeight - buy.offsetHeight - 16)}px`;
  };
  setStickyTop();
  window.addEventListener('resize', setStickyTop);
  if ('ResizeObserver' in window && buy) new ResizeObserver(setStickyTop).observe(buy);

  // Sterne springen zu den Bewertungen
  root.querySelector('[data-mdp-to-reviews]')?.addEventListener('click', e => {
    const reviews = document.querySelector('[id$="__product-reviews"]');
    track('mm_probier_reviews', { via: 'stars' });
    if (!reviews) return;
    e.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Aufgeklappte Bereiche (Nährwerte, Zubereitung, SEO-Text)
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    if (!root.contains(d) && !d.classList.contains('MDP__Seo')) return;
    track('mm_probier_section_open', { pdp_section: d.querySelector('summary')?.textContent.trim().slice(0, 60) || '' });
  }, true);

  // SEO-Texte bleiben im HTML, werden auf dieser Vorlage aber eingeklappt
  const seo = document.querySelector('[id$="__product-seo-texte"] .Container');
  if (seo && !seo.closest('details')) {
    const details = document.createElement('details');
    details.className = 'MDP__Seo';
    const summary = document.createElement('summary');
    summary.textContent = t('seo_title', 'Mehr über Löwenanteil');
    details.appendChild(summary);
    while (seo.firstChild) details.appendChild(seo.firstChild);
    seo.appendChild(details);
  }

  // Welche Abschnitte werden erreicht (einmal pro Seitenaufruf)
  const reachTargets = [
    ['kaufbereich', el.add], ['inhalt', $('.PPD__Contents:not([hidden])')], ['mix_match', $('[data-ppd-mm]')],
    ['bewertungen', document.querySelector('[id$="__product-reviews"]')], ['faq', document.querySelector('[id$="__product-faq"]')],
  ].filter(([, node]) => node);
  const reached = new Set();
  const checkReach = () => {
    reachTargets.forEach(([name, node]) => {
      if (reached.has(name)) return;
      const r = node.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.8 && r.bottom > 0) { reached.add(name); track('mm_probier_reach', { pdp_section: name }); }
    });
  };
  window.addEventListener('scroll', () => setTimeout(checkReach, 150), { passive: true });
  setTimeout(checkReach, 800);

  // Nährwerttabellen sauber aufbereiten (je Gericht eine Tabelle, Gerichtsname als Zwischenüberschrift)
  root.querySelectorAll('.MDP__AccBody').forEach(body => {
    body.querySelectorAll('[style]').forEach(n => n.removeAttribute('style'));
    body.querySelectorAll('table').forEach(table => {
      const rows = Array.from(table.rows).map(tr => Array.from(tr.cells).map(td => td.innerHTML.split(/<br\s*\/?>/i).map(part => part.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim())));
      if (!rows.length) return;
      const out = document.createElement('table');
      out.className = 'MDP__NutTable';
      rows.forEach((cells, ri) => {
        const lines = Math.max(...cells.map(c => c.length));
        for (let li = 0; li < lines; li++) {
          const tr = document.createElement(ri === 0 ? 'thead' : 'tr');
          const row = ri === 0 ? document.createElement('tr') : tr;
          cells.forEach((c, ci) => {
            const cell = document.createElement(ri === 0 ? 'th' : 'td');
            const text = c[li] ?? '';
            if (ci > 0 && /kJ\s*\/\s*\d/.test(text)) {
              const [kj, kcal] = text.split('/');
              cell.append(kj.trim(), document.createElement('br'), kcal.trim());
            } else {
              cell.textContent = text;
            }
            if (ci > 0) cell.className = 'is-num';
            row.appendChild(cell);
          });
          if (ri > 0 && /^davon/i.test(cells[0][li] || '')) row.classList.add('is-sub');
          if (ri === 0) { tr.appendChild(row); out.appendChild(tr); } else { out.appendChild(tr); }
        }
      });
      const wrap = document.createElement('div');
      wrap.className = 'MDP__NutWrap';
      wrap.appendChild(out);
      table.replaceWith(wrap);
    });
    // Je Gericht wie auf der Gerichte-Seite: „Zutaten“ und „Nährwerte“ als Zwischenüberschriften
    const first = body.querySelector('p');
    if (first && /^Zutaten/i.test(first.textContent.trim())) {
      first.classList.add('MDP__Ingredients');
      first.innerHTML = first.innerHTML
        .replace(/^\s*<strong>Zutaten<\/strong>/i, '')
        .replace(/^(\s|&nbsp;|:|<span>|<\/span>)+/i, '');
      const h = document.createElement('h3');
      h.className = 'MDP__SubH';
      h.textContent = 'Zutaten';
      first.before(h);
      const wrap = body.querySelector('.MDP__NutWrap');
      if (wrap) { const h2 = document.createElement('h3'); h2.className = 'MDP__SubH'; h2.textContent = 'Nährwerte'; wrap.before(h2); }
    }
    body.querySelectorAll('p').forEach(p => {
      const t = p.textContent.trim();
      if (/^\(?[A-Z]{2}-BIO-\d+/.test(t) || /^\*/.test(t)) p.classList.add('MDP__Fine');
    });
  });

  readCart().then(render).catch(() => render());
  render();
  track('mm_probier_view', { value: active.final / 100, currency: CUR });
})();
